import React, { useContext, useEffect, useState } from "react";
import "../../stylesheet/forms.css";
import { FaRegTrashAlt } from "react-icons/fa";
import ContextApi from "../../context/ContextApi";

const BillingDetails = ({ onContinue, goBack }) => {
  const { product, setProducts, formData, setFormData } =
    useContext(ContextApi);
  const [personnel_type, setPersonelType] = useState(null);
  const [patientDetails, setPatientDetails] = useState(null);
  const deliveryFee = 2000;
  const discount = 0;

  const responsibleDeptInitials = [
    { id: 1, status: false, tag: "Accident, Casualty and Emergency" },
    { id: 2, status: false, tag: "Surgery (operating theater)" },
    { id: 3, status: false, tag: "Outpatient" },
    { id: 4, status: false, tag: "Intensive Care Unit" },
    { id: 5, status: false, tag: "Cardiology" },
    { id: 6, status: false, tag: "Neurology" },
    { id: 7, status: false, tag: "Psychiatry" },
    { id: 8, status: false, tag: "Radiology" },
    { id: 9, status: false, tag: "Medical Laboratory" },
    { id: 10, status: false, tag: "Pharmacy" },
    { id: 11, status: false, tag: "Rehabilitation and Therapy" },
    { id: 12, status: false, tag: "ENT section" },
    { id: 13, status: false, tag: "Geriatric" },
    { id: 14, status: false, tag: "Gastroenterology" },
    { id: 15, status: false, tag: "Hematology" },
    { id: 16, status: false, tag: "Pediatrics" },
    { id: 17, status: false, tag: "Oncology" },
    { id: 18, status: false, tag: "Ophthalmology" },
    { id: 19, status: false, tag: "Urology" },
    { id: 20, status: false, tag: "Orthopedic" },
    { id: 21, status: false, tag: "Nursing" },
    { id: 22, status: false, tag: "Nutrition and Dietetics" },
  ];

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setPatientDetails({
      ...patientDetails,
      [name]: value,
    });
  };
  const calculateSubTotal = () => {
    let total = 0;
    product.forEach((item) => {
      total += item.price * item.count;
    });
    return total;
  };
  const handleNext = () => {
    setFormData({
      ...patientDetails,
      personnel_type,
      client_type: patientDetails?.client_type ?? "patient",
      items: [...product],
      discount,
      deliveryFee,
      invoiceType: 'inventory',
      subTotal: calculateSubTotal(),
      total: discount + deliveryFee + calculateSubTotal()
    });
    onContinue();
  };
  useEffect(() => {
    let newProducts = [...product];
    newProducts = newProducts.map((product) => ({ ...product, count: 1 }));
    setProducts(newProducts);
    if(formData ) {
      setPatientDetails(formData)
    } 
  }, []);

  return (
    <>
      <section className="md:flex justify-between gap-3 w-full p-10">
        <div className="step_form w-full lg:w-[70%] step_form border rounded">
          <h1 className="text-[30px]">Create Invoice</h1>
          <hr />

          {!personnel_type ? (
            <div className="flex justify-center my-20 gap-10">
              <div className="my-8">
                <div
                  className="border border-grey-100 w-full md:w-[220px] mb-3 rounded-[5px] p-2 capitalize relative cursor-pointer"
                  key="patient"
                  onClick={(e) => setPersonelType("patient")}
                >
                  {personnel_type == "patient" && (
                    <div className="rounded-full w-4 h-4 bg-primary text-white absolute right-2">
                      <div className="flex justify-center align-middle text-[11px]">
                        {"✓"}
                      </div>
                    </div>
                  )}
                  <div className="font-bold">
                    <div className="flex justify-between gap-2">
                      <p> </p>
                    </div>
                  </div>
                  <div className="text-center mx-auto">
                    <h2 className="">For Patient</h2>
                  </div>
                </div>
              </div>
              <div className="my-8">
                <div
                  className="border border-grey-100 w-full md:w-[220px] mb-3 rounded-[5px] p-2 capitalize relative cursor-pointer"
                  key="company"
                  onClick={(e) => setPersonelType("company")}
                >
                  {personnel_type == "company" && (
                    <div className="rounded-full w-4 h-4 bg-primary text-white absolute right-2">
                      <div className="flex justify-center align-middle text-[11px]">
                        {"✓"}
                      </div>
                    </div>
                  )}
                  <div className="font-bold">
                    <div className="flex justify-between gap-2">
                      <p> </p>
                    </div>
                  </div>
                  <div className="text-center mx-auto">
                    <h2 className="">For Partner/Company</h2>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="step_input">
                <label htmlFor="name">
                  {personnel_type == "patient" ? (
                    <span className="text-primary font-medium text-2xl">
                      Patient name
                    </span>
                  ) : (
                    <span className="text-primary font-medium text-2xl">
                      Partner/Company name
                    </span>
                  )}
                </label>
                <input
                  name="name"
                  type="text"
                  defaultValue={patientDetails?.name}
                  placeholder="Enter Patient name"
                  onChange={handleInputChange}
                />
              </div>

              {personnel_type == "company" && (
                <div className="step_input">
                  <label htmlFor="brand">Client type</label>
                  <select
                    name="client_type"
                    id="client_type"
                    value={patientDetails?.client_type}
                    onChange={handleInputChange}
                  >
                    <option disabled selected>
                      Select client type
                    </option>
                    <option disabled value={""}>
                      Select client type
                    </option>
                    <option value="provider-hospital">
                      Provider - Hospital
                    </option>
                    <option value="provider-pharmacy">
                      {" "}
                      Provider - Pharmacy
                    </option>
                    <option value="provider-laboratory">
                      Provider - Laboratory
                    </option>
                    <option value="provider-diagnostic-imaging">
                      Provider - Diagnostic Imaging
                    </option>
                    <option value="provider-others">Provider - Others</option>
                    <option value="payer-health-insurance">
                      Payer - Health Insurance
                    </option>
                    <option value="payer-employer"> Payer - Employer</option>
                    <option value="payer-donor_ngo">
                      {" "}
                      Payer - Donor & NGO
                    </option>
                    <option value="payer-government">
                      {" "}
                      Payer - Government
                    </option>
                    <option value="payer-others">Payer - Others</option>
                  </select>
                </div>
              )}

              <div className="step_inputs">
                <label htmlFor="description">Description</label>
                <input
                  type="textarea"
                  id="description"
                  defaultValue={patientDetails?.description}
                  className="h-[50px]"
                  placeholder="Enter a description..."
                  name="description"
                  onChange={handleInputChange}
                />
              </div>

              <div className="step_input">
                <label htmlFor="brand">Responsibile Department</label>
                <select
                  name="responsible_dept"
                  id="responsible_dept"
                  value={patientDetails?.responsible_dept}
                  onChange={handleInputChange}
                >
                  <option disabled selected>
                    Select Responsibile Department
                  </option>
                  {responsibleDeptInitials.map((item) => (
                    <option key={`${item.id}-billing`} value={item.tag}>
                      {item.tag}
                    </option>
                  ))}
                </select>
              </div>

              <div className="step_input mt-3">
                <label htmlFor="date">Due Date</label>
                <div className="custom_date">
                  <input
                    defaultValue={patientDetails?.date}
                    className="date_input" 
                    onChange={handleInputChange}
                    type="date"
                    id="date"
                    name="date"
                    placeholder="DD/MM/YYYY"
                  />
                </div>
              </div>
            </>
          )}
        </div>
        <div className="w-full lg:w-[30%] border-primary rounded-md border p-3">
          {product && product.length ? (
            <div className="h-96 overflow-y-scroll">
              {product.map((item, index) => (
                <div className="" key={`${index}-productItem`}>
                  <div>
                    <div className="flex justify-between w-full mb-6 align-baseline">
                      <div className="w-4/6 items-baseline">
                        <p className="capitalize font-bold  overflow-ellipsis w-100">
                          {item?.name}
                        </p>
                        <p>
                          {item.unit_quantity}
                          {item.measurement}
                        </p>
                        <p className="">₦{item.price}</p>
                      </div>
                      <div className="w-2/6 text-right">
                        <p className="text-right flex justify-end my-3">
                          <FaRegTrashAlt
                            color="red"
                            className="cursor-pointer"
                            onClick={(item, id) => {
                              const newProducts = [...product];
                              newProducts.splice(id, 1);
                              setProducts(newProducts);
                            }}
                          />
                        </p>
                        <button
                          className="border border-red-400 text-red-400 px-[8px] py-[1px] rounded-md"
                          onClick={() => {
                            const newProducts = [...product];
                            if (!(item.count <= 1)) {
                              newProducts[index].count -= 1;
                              setProducts(newProducts);
                            }
                          }}
                        >
                          -
                        </button>
                        <span className="mx-2">{item.count}</span>
                        <button
                          className="bg-green-500 text-white px-[8px] py-[1px] rounded-md"
                          onClick={() => {
                            const newProducts = [...product];
                            newProducts[index].count += 1;
                            setProducts(newProducts);
                          }}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="italic">No product in Cart yet</div>
          )}

          <div className="border-t ">
            <div className="flex justify-between items-center my-2">
              <div>Sub Total</div>
              <div>₦ {calculateSubTotal()}</div>
            </div>
            <div className="flex justify-between items-center my-2">
              <div>Delivery Fee</div>
              <div>₦ {deliveryFee}</div>
            </div>
            <div className="flex justify-between items-center my-2">
              <div>Discount</div>
              <div>- ₦ {discount}</div>
            </div>
            <div className="flex justify-between items-center my-4 border-t pt-2">
              <div className="font-bold">Total</div>
              <div>₦ {discount + deliveryFee + calculateSubTotal()}</div>
            </div>
            <div className="flex justify-between gap-3 items-center my-2 pt-4">
              <button
                className="border border-primary text-primary px-[16px] py-[6px] rounded-md w-full"
                onClick={goBack}
              >
                Back
              </button>
              <button
                disabled={false} //add conditionals to show abled button
                className="border bg-primary text-white px-[16px] py-[6px] rounded-md w-full"
                onClick={handleNext}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BillingDetails;
